{{#each envInstance.generateGroups delimeter="\n\n"}}
{{> partials/snippets/bind-generate-block env=../env dimensionPropertiesList=dimensionPropertiesList blockNamePrefix=blockNamePrefixes.bind envInstanceHierarchicalProperties=envInstanceHierarchicalProperties}}
{{/each}}
